import React, { useContext, useEffect } from 'react';
import { dashboards } from '../../services/enums';
import { LoadingSpinner, toast } from '../../components/common';
import AgentDashboard from './agentDashboard';
import TeamDashboard from './teamDashboard';
import AdminDashboard from './adminDashboard';
import CODIFIDashboard from './codifiDashboard';
import { UserContext } from '../../contexts/user';
import { toastOptions } from '../../components/common/toast';

const Home = () => {
    const { rolePermissions, isLoading } = useContext(UserContext);
    const rolePermission = rolePermissions?.find((rp) => rp.permissiongroupid === 'd');

    useEffect(() => {
        //try get microphone access and warn if unavailable
        navigator.mediaDevices
            .getUserMedia({ video: false, audio: true })
            .then((stream) => {
                try {
                    window.localStream = stream;
                    if (window.localAudio) {
                        window.localAudio.srcObject = stream;
                        window.localAudio.autoplay = true;
                    }
                } catch (err) {
                    console.error(err);
                }
            })
            .catch((err) => {
                toast.error(
                    'You must allow access to your microphone for this application to work correctly.',
                    { ...toastOptions, autoClose: false, closeOnClick: false }
                );
                console.error(err);
            });

        //try get popup access and warn if disabled
        try {
            var popup = window.open('about:blank', '_blank');
            if (!popup) {
                toast.error('You must allow pop-ups for this application to work correctly.', {
                    ...toastOptions,
                    autoClose: false,
                    closeOnClick: false,
                });
            }
            popup.close();
        } catch {}
    }, []);

    const renderDashboard = () => {
        switch (rolePermission?.id) {
            case dashboards.teamLeader:
                return <TeamDashboard />;
            case dashboards.admin:
                return <AdminDashboard />;
            case dashboards.codifi:
                return <CODIFIDashboard />;
            case dashboards.agent:
                return <AgentDashboard />;
            default:
                if (isLoading) return <LoadingSpinner />;
                return <AgentDashboard />;
        }
    };

    return <div>{renderDashboard()}</div>;
};

export default Home;
